// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M15.4897 3.57529L12.0002 0.0856934L8.51056 3.57529H3.57553V8.51032L0.0859375 11.9999L3.57553 15.4895V20.4245H8.51056L12.0002 23.9141L15.4897 20.4245H20.4248V15.4895L23.9144 11.9999L20.4248 8.51031V3.57529H15.4897ZM12.0007 17C11.3708 17 10.7681 16.8835 10.2129 16.6709C11.3236 15.4319 11.9991 13.7949 11.9991 12C11.9991 10.2051 11.3236 8.56806 10.2129 7.32913C10.7681 7.1165 11.3708 7 12.0007 7C14.7622 7 17.0007 9.23857 17.0007 12C17.0007 14.7614 14.7622 17 12.0007 17Z"}}]};

const Brightness1FilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'brightness-1-filled',
    ref,
    icon: element,
  },
));

Brightness1FilledIcon.displayName = 'Brightness1FilledIcon';

export default Brightness1FilledIcon;
